import { TweenMax, Power0 } from 'gsap';
import Fullscreen from '../../helpers/fullscreen';
var Signal = require('signals');

var Header = function() {
    var elBoat = document.getElementById('header-boat');
    var elScoreContainer = document.querySelector('.header-score');
    var elScoreEndContainer = document.querySelector('.header-score-end');
    var elScore = elScoreContainer.querySelector('.score');
    var elScoreEnd = elScoreEndContainer.querySelector('.score');
    var elScoreEndGlow = elScoreEndContainer.querySelector('.header-score-end__img-glow');
    var elHeader = document.getElementById('header');
    var elHeaderSteps = elHeader.querySelector('.header-steps');
    var elShield = document.getElementById('header-shield');
    var elButtonsContainer = document.getElementById('header-buttons');
    var elFullscreen = document.getElementById('header-fullscreen-btn');
    var elSound = document.getElementById('header-sound-btn');
    var elSoundOff = elSound.querySelector('.sound-off')
    var elSoundOn = elSound.querySelector('.sound-on')

    // var oFullscreen = new Fullscreen();

    var nTime = window.DEBUG_GAME_TIME ? window.DEBUG_GAME_TIME : 45;
    var xStart = 606;
    var xEnd = 1290;
    var xLength = xEnd - xStart - elBoat.width;

    var windowW, windowH;

    var signal = new Signal.Signal();

    var init = function() {
      // TweenMax.set(elHeader, {top:-200});
      elFullscreen.addEventListener('click', openFullscreen);
      elSound.addEventListener('click', switchSounds)
      resize()
      showInitial()
    }

    var openFullscreen = function() {
      console.log(`OPEN FULLSCREEN`);
      signal.dispatch('fullscreen')
    }

    var show = function() {
      // TweenMax.to(elHeader, 0.3, {top:0});
    }

    var hide = function() {
      // TweenMax.to(elHeader, 0.3, {top:-200});
    }

    // 8s, 15s, 22s
    var palier1 = Math.round(100 * 8/45) / 100;
    var palier2 = Math.round(100 * 15/45) / 100;
    var palier3 = Math.round(100 * 22/45) / 100;

    console.log(`Les PALIERS en %`);
    console.log(`   palier1 ${palier1}`);
    console.log(`   palier2 ${palier2}`);
    console.log(`   palier3 ${palier3}`);

    // Have the same in bottles.js, not used, instead added more bottles if mobile
    var bMobile = window.innerWidth < 769
    var COEF_MOBILE = 1; //1.1;

    var start = function(callbackOnUpdate) {
      var bStep0 = false;
      var bStep1 = false;
      var bStep2 = false;
      TweenMax.to(elBoat, bMobile ? nTime / COEF_MOBILE : nTime, {
        left: xEnd - elBoat.width,
        ease: Power0.easeNone,
        onUpdate: () => {
          callbackOnUpdate();
          let p = (parseInt(elBoat.style.left, 10) - xStart) / xLength;
          if (!bStep0 && p < palier1) {
            bStep0 = true;
            signal.dispatch('step1');
          } else if (!bStep1 && p > palier1) {
            bStep1 = true;
            updateLevel(1);
            signal.dispatch('step2');
          } else if (!bStep2 && p > palier3) {
            bStep2 = true;
            updateLevel(2);
            signal.dispatch('step3');
          }
        },
        onComplete: () => {
          updateLevel(3);
          setTimeout(() => {
            signal.dispatch('end_game');
          }, 1000);
        }
      });
    }

    var resize = function() {
      windowW = window.innerWidth
      windowH = window.innerHeight
      TweenMax.set(elHeader, {
        transformOrigin: 'top left',
        scale: windowW / 1920,
        transformStyle: 'preserve-3d'
      });
      TweenMax.set(elButtonsContainer, {
        transformOrigin: 'top left',
        scale: windowW / 1920,
        transformStyle: 'preserve-3d'
      });
    }

    var reset = function () {
        TweenMax.to(elBoat, 0.2, {opacity:0, onComplete:()=>{
            TweenMax.set(elBoat, {left:xStart});
            TweenMax.to(elBoat, 0.2, {opacity:1});
        }});
        updateLevel(0);
        updateScore(0);
    }

    var updateScore = function(n) {
        elScore.innerHTML = n;
    }

    var updateLevel = function(levelId) {
        for(var i = 0; i < 4; i++) {
            elShield.querySelector(`.js-shield-${i}`).style.display = i == levelId ? 'block' : 'none';
        }
    }

    var switchSounds = function() {
      signal.dispatch('switchsound');
    }

    var setSoundIsActive = function(b) {
      elSoundOff.style.opacity = b ? 0 : 1
      elSoundOn.style.opacity = b ? 1 : 0
    }

    var showInitial = function() {
      TweenMax.to(elHeaderSteps, 0.5, {autoAlpha: 1})
      TweenMax.to(elScoreContainer, 0.5, {autoAlpha: 1})
      TweenMax.to(elBoat, 0.5, {autoAlpha: 1})
      TweenMax.to(elScoreEndContainer, 0.5, {autoAlpha: 0})
    }

    var showEnd = function(score) {
      console.log(`Header showEnd`, score);

      TweenMax.to(elHeaderSteps, 0.5, {autoAlpha: 0})
      TweenMax.to(elScoreContainer, 0.5, {autoAlpha: 0})
      TweenMax.to(elBoat, 0.5, {autoAlpha: 0})
      TweenMax.to(elScoreEndContainer, 0.5, {autoAlpha: 1, delay: 1, onComplete: () => {
        TweenMax.set(elScoreEndGlow, {opacity: 0})
        TweenMax.to(elScoreEndGlow, 0.5, {opacity: 1, yoyo: true, repeat: 50})
      }})

      elScoreEnd.innerHTML = `${score}`
    }

    return {
        init,
        start,
        show,
        hide,
        resize,
        reset,
        updateScore,
        updateLevel,
        setSoundIsActive,
        showEnd,
        signal
    }
}

export {Header as default};
